/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/extensions */
import {
  FieldOrGroup,
  Fields,
  FieldSettings,
  MultiSelectFieldSettings,
  RuleValue,
  ValueSource,
} from '@react-awesome-query-builder/antd';
import { Card, Button } from 'antd';
import { useEffect, useState } from 'react';
import SQL_QUERY_BUILDER_CONSTANT from './constant/SQL_QUERY_BUILDER_CONSTANT';
import SQLMode from './mode_components/sqlMode';
import SingleMode from './mode_components/singleMode';
import { ListValues, Operator, Widget } from '@react-awesome-query-builder/core';
import { BaseSimpleField } from './interfaces/versionInterfaces';


const SQLQueryBuilder = ({
  label,
  onSave,
  value = {},
  config,
  handleOnQueryChange,
  showButtons,
  editFormula,
  showEditor,
  handleEditMode
}: {
  label?: string,
  onSave: Function;
  value: any;
  config: any;
  handleOnQueryChange?: any
  showButtons: boolean,
  editFormula?:boolean,
  showEditor: boolean,
  handleEditMode: Function
}) => {
  const [fields, setFields] = useState<Fields>(null);
  const createFields = (columns) => {
    const finalFields: Fields = {};
    columns.forEach((column: any) => {
      const finalColumnObj: any = {
        type: '',
        label: column?.name || '',
        valueSources: ['value'],
      };
      switch (column?.dataType) {
        case 'string':
          finalColumnObj.type = 'text';
          break;

        default:
          finalColumnObj.type = column?.dataType;
          break;
      }
      if (column?.columnType === 'master') {
        finalColumnObj.type = 'select';
        finalColumnObj.fieldSettings = {
          listValues: column?.master,
        } as MultiSelectFieldSettings;
      }

      finalFields[column?.name] = finalColumnObj;
    });
    return finalFields;
  };
  useEffect(() => {
    if (config.columns) {
      setFields(createFields(config.columns));
    }
  }, [config]);

  if (!fields) return <div>Loading...</div>;



  return (
    <div key={JSON.stringify(fields)}>
      {config.mode === SQL_QUERY_BUILDER_CONSTANT.MODE.SQL ? (
        <SQLMode handleEditMode={handleEditMode} showButtons={showButtons} showEditor={showEditor} value={value} fields={fields} onSave={onSave} handleOnQueryChange={handleOnQueryChange} editFormula={editFormula} />
      ) : null}

      {config.mode === SQL_QUERY_BUILDER_CONSTANT.MODE.SINGLE ? (
        <SingleMode label={label} handleEditMode={handleEditMode} showButtons={showButtons} showEditor={showEditor} value={value} fields={fields} onSave={onSave} handleOnQueryChange={handleOnQueryChange} editFormula={editFormula} />
      ) : null}
    </div>
  );
};
export default SQLQueryBuilder;
